import { GENERAL_STATUS } from '../constants/constants';

export const cn = (...classnames: Array<string | undefined | null>) =>
  classnames.filter(Boolean).join(' ');

export const getGeneralStatusSelectOptions = () => [
  { label: 'Active', value: GENERAL_STATUS.ACTIVE },
  { label: 'Inactive', value: GENERAL_STATUS.INACTIVE },
];
